module.exports = __webpack_public_path__ + "static/media/dis_en.84603676.png";